import React, { useState } from 'react';

import type { ModelSocialIntegration } from '@app/api/SocialIntegrations';
import type { EditMode } from '@app/pages/Integrations/IntegrationsList/components/Edit1CIntegrationModal/types';
import { IntegrationsContext } from '@app/providers/IntegrationsProvider/IntegrationsContext';
import type { NIntegrationProvider } from '@app/providers/IntegrationsProvider/IntegrationsProvider.types';

const Context = React.createContext('');

export const IntegrationsProvider: NIntegrationProvider.Main = ({
  children,
}) => {
  const [isWhatsAppModalOpen, setIsWhatsAppModalOpen] = useState(false);
  const [isInstagramFrameOpen, setIsInstagramFrameOpen] = useState(false);
  const [isAtcModalOpen, setIsAtcModalOpen] = useState(false);
  const [isSocialMediaSettingsModalOpen, setIsSocialMediaSettingsModalOpen] =
    useState(false);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [currentIntegrationType, setCurrentIntegrationType] = useState('');
  const [integrations, setIntegrations] = useState<ModelSocialIntegration[]>(
    []
  );
  const [
    isOpenAddWhatsAppIntegrationWarningModal,
    setIsOpenAddWhatsAppIntegrationWarningModal,
  ] = useState(false);
  const [isYooKassaModalOpen, setIsYooKassaModalOpen] = useState(false);
  const [isAdd1CIntegrationModalOpen, setIsAdd1CIntegrationModalOpen] =
    useState(false);

  const [isEdit1CIntegrationModalOpen, setIsEdit1CIntegrationModalOpen] =
    useState(false);
  const [edit1CIntegrationId, setEdit1CIntegrationId] = useState<number | null>(
    null
  );
  const [edit1CIntegrationMode, setEdit1CIntegrationMode] =
    useState<EditMode>('edit');
  const [currentYooKassaIntegrationId, setCurrentYooKassaIntegrationId] =
    useState<number | null>(null);
  // Кнопку выгрузки журнала рисует шапка страницы, а правило видимости
  // считается на самой странице — там есть список интеграций (us/11024).
  const [isExportLogVisible, setIsExportLogVisible] = useState(false);

  return (
    <IntegrationsContext.Provider
      value={{
        isWhatsAppModalOpen,
        setIsWhatsAppModalOpen,
        isEmailModalOpen,
        setIsEmailModalOpen,
        setCurrentIntegrationType,
        currentIntegrationType,
        integrations,
        setIntegrations,
        isOAuthFrameOpen: isInstagramFrameOpen,
        setIsOAuthFrameOpen: setIsInstagramFrameOpen,
        isSocialMediaSettingsModalOpen,
        setIsSocialMediaSettingsModalOpen,
        isAtcModalOpen,
        setIsAtcModalOpen,
        setIsOpenAddWhatsAppIntegrationWarningModal,
        isOpenAddWhatsAppIntegrationWarningModal,
        isYooKassaModalOpen,
        setIsYooKassaModalOpen,
        isAdd1CIntegrationModalOpen,
        setIsAdd1CIntegrationModalOpen,
        isEdit1CIntegrationModalOpen,
        setIsEdit1CIntegrationModalOpen,
        edit1CIntegrationId,
        setEdit1CIntegrationId,
        edit1CIntegrationMode,
        setEdit1CIntegrationMode,
        currentYooKassaIntegrationId,
        setCurrentYooKassaIntegrationId,
        isExportLogVisible,
        setIsExportLogVisible,
      }}
    >
      <Context.Provider value={''}>{children}</Context.Provider>
    </IntegrationsContext.Provider>
  );
};
